import type { TranslationDictionary } from "./types";

export const es: TranslationDictionary = {
  // ── EmailGate ──
  "emailGate.exclusiveProposal": "Propuesta Exclusiva",
  "emailGate.yourProposalIsReady": "Tu propuesta personalizada está lista",
  "emailGate.enterEmail": "Ingresa tu correo para acceder",
  "emailGate.placeholder": "tu@correo.com",
  "emailGate.invalidEmail": "Por favor, ingresa un correo válido",
  "emailGate.blockedEmail":
    "Por favor, ingresa un correo corporativo o personal válido",
  "emailGate.accessProposal": "Accede a tu propuesta exclusiva",
  "emailGate.loading": "Cargando...",
  "emailGate.notFound": "Propuesta no encontrada",
  "emailGate.loadError":
    "No fue posible cargar la propuesta. Verifica el enlace o intenta de nuevo.",
  "emailGate.retry": "Intentar de Nuevo",
  "emailGate.socialProof": "+2.000 empresas confían en Woba",
  "emailGate.footer": "Powered by Woba",
  "emailGate.proposalLoadError":
    "Error al cargar la propuesta. Intenta de nuevo.",

  // ── ProposalContent ──
  "proposal.notFoundOrExpired": "Propuesta no encontrada o expirada.",

  // ── HeroSection ──
  "hero.preparedFor": "Preparado para {{companyName}}",
  "hero.titleWithCity": "Tu oficina en {{city}}, lista para operar.",
  "hero.titleNoCity": "Tu oficina, lista para operar.",
  "hero.optionSingular": "opción seleccionada",
  "hero.optionPlural": "opciones seleccionadas",
  "hero.allInclusive": "· Todo incluido · Un único contrato.",
  "hero.spaceSingular": "{{count}} espacio seleccionado",
  "hero.spacePlural": "{{count}} espacios seleccionados",
  "hero.readyInCity": "Listos para operar en {{city}}",
  "hero.readyToOperate": "Listos para operar",
  "hero.singleContract": "Un único contrato",
  "hero.singleContractDesc": "Para todos los espacios de la empresa",
  "hero.centralizedManagement": "Gestión centralizada",
  "hero.centralizedManagementDesc": "Sin burocracia, sin sorpresas",
  "hero.bestPrice": "Mejor precio garantizado",
  "hero.bestPriceDesc": "Paridad de precio con contratación directa",
  "hero.startingFrom": "Desde",
  "hero.perPositionMonth": "/posición/mes",
  "hero.viewSpaces": "Ver espacios",
  "hero.pricesGuaranteedUntil": "Precios garantizados hasta {{date}}",
  "hero.contractTermLabel": "Plazo del contrato",
  "hero.contractTerm.6": "6 meses",
  "hero.contractTerm.12": "12 meses",
  "hero.contractTerm.24": "24 meses",
  "hero.contractTerm.36": "36 meses",

  // ── Chat ──
  "chat.contextLabel": "Respondiendo dudas sobre",
  "chat.placeholder": "Pregunta sobre este espacio...",
  "chat.welcomeLine1":
    "¡Hola! 👋 Estoy aquí para resolver tus dudas sobre **{{spaceName}}**.",
  "chat.welcomeDetailsPrefix": "Este espacio está ubicado",
  "chat.welcomeAt": "en {{address}}",
  "chat.welcomeCapacity": "con capacidad para **{{capacity}} posiciones**",
  "chat.welcomePrice": "a **R$ {{price}}/posición/mes**",
  "chat.welcomeAskAnything":
    "Pregunta lo que quieras — ¡o haz clic en las sugerencias abajo!",
  "chat.errorMessage":
    "Lo sentimos, ocurrió un error al procesar tu mensaje. Intenta de nuevo.",
  "chat.dividerNowAbout": "Ahora sobre: {{spaceName}}",
  "chat.sendAriaLabel": "Enviar",
  "chat.chip.monthlyValue": "¿Cuál es el valor mensual?",
  "chat.chip.parking": "¿Tiene estacionamiento?",
  "chat.chip.internet": "¿Cuál es la velocidad del internet?",
  "chat.chip.meetingRooms": "¿Incluye salas de reunión?",
  "chat.chip.credits": "¿Cómo funcionan los créditos Woba?",
  "chat.chip.contract": "¿Cuál es la flexibilidad del contrato?",
  "chat.chip.scheduleVisit": "Quiero agendar una visita",

  // ── SpacesSection ──
  "spaces.selectedSpaces": "Espacios Seleccionados",
  "spaces.optionsFor": "Opciones para {{companyName}}",
  "spaces.optionsForDefault": "Opciones para tu empresa",
  "spaces.bestOfficesInCity":
    "Seleccionamos las mejores oficinas en {{city}} para tu operación",
  "spaces.bestOptions": "Seleccionamos las mejores opciones para tu operación",
  "spaces.availableOptions": "Opciones Disponibles",
  "spaces.recommended": "★ Recomendado",
  "spaces.combo": "Conjunto",
  "spaces.pos": "pos",
  "spaces.tabPhotos": "Fotos",
  "spaces.tabMap": "Mapa",
  "spaces.tabAmenities": "Amenidades",
  "spaces.tabChat": "Dudas",
  "spaces.scopeOffice": "Oficina Privada",
  "spaces.scopeSpace": "Espacio",
  "spaces.tabNavLabel": "Navegación del espacio",
  "spaces.fullscreenTitle": "Ubicación de los Espacios",

  // ── PhotosTab ──
  "photos.noImage": "Sin imagen disponible",
  "photos.didYouLike": "¿Te gustó?",
  "photos.liked": "Me gustó",
  "photos.disliked": "No me gustó",
  "photos.positions": "posiciones",
  "photos.perMonth": "/mes",
  "photos.costRent": "Alquiler + Condominio + Impuestos 53%",
  "photos.costServices": "Servicios 32%",
  "photos.costSupport": "Soporte 15%",
  "photos.perPosition": "R$ {{price}} por posición",
  "photos.priceOnRequest": "Valor bajo consulta",
  "photos.licenseFee": "License Fee R$ {{price}}",
  "photos.licenseFeeIncluded": "License Fee incluido",

  // ── AmenitiesTab ──
  "amenities.notAvailable": "Información de amenidades no disponible.",

  // ── MapTab ──
  "map.coworkings": "Coworkings",
  "map.fullscreen": "Pantalla completa",
  "map.fullscreenAriaLabel": "Ver mapa en pantalla completa",
  "map.calculateDistance": "Calcular distancia desde...",
  "map.placeholder": "Ej: Av. Paulista, 1000",
  "map.searching": "Buscando...",
  "map.calculate": "Calcular",
  "map.distancesFrom": "Distancias desde",
  "map.addressNotProvided": "Dirección no informada",
  "map.selectedNoAddress": "Dirección no informada para esta opción",
  "map.recenter": "Centrar",
  "map.recenterTitle": "Centrar el mapa",
  "poi.noDescription": "Sin descripción",

  // ── ComparisonSection ──
  "comparison.heading":
    "La forma más inteligente de contratar y administrar oficinas.",
  "comparison.subheadingPre":
    "Abandona las complejidades del modelo tradicional y",
  "comparison.subheadingBold":
    "centraliza todo en un único contrato inteligente",
  "comparison.subheadingPost": "— cambia al modelo Woba y descubre.",
  "comparison.tabTraditional": "Alquiler tradicional",
  "comparison.tabWoba": "Woba",
  "comparison.traditional.title": "Los costos que olvidas sumar.",
  "comparison.traditional.desc":
    "Porque en el modelo tradicional, el valor del alquiler es solo el comienzo.",
  "comparison.woba.title": "Un valor único, sin sorpresas",
  "comparison.woba.desc":
    "Con el modelo Woba, tienes un valor único, sin sorpresas — del alquiler a la limpieza.",

  // ── SpaceComparisonTable ──
  "table.badge": "Comparativo",
  "table.heading": "Comparativo por Espacio",
  "table.subheading":
    "Todas las opciones lado a lado para facilitar tu decisión",
  "table.colSpace": "Espacio",
  "table.colLocation": "Ubicación",
  "table.colPositions": "Posiciones",
  "table.colArea": "Área",
  "table.colPricePerPosition": "R$/Posición",
  "table.colCreditsPerPosition": "Créditos/Posición",
  "table.colMonthly": "Mensualidad",
  "table.colCreditsMonth": "Créditos/Mes",
  "table.colLicenseFee": "License Fee",
  "table.licenseFeeTooltip": "Valor pagado una sola vez",
  "table.colVisit": "Visitar",
  "table.included": "Incluido",
  "table.belowMarket": "▼ {{pct}}% debajo del mercado",
  "table.wantToVisit": "Quiero visitar",
  "table.selected": "Seleccionado",
  "table.sent": "Enviado",
  "table.bestPriceGuarantee": "Garantía de mejor precio",
  "table.bestPriceDesc": "— Mismo valor que la contratación directa.",
  "table.marketSource":
    "Comparado con el promedio de mercado de la región. Fuente: base Woba.",
  "table.credits": "Créditos",
  "table.visitBarSingular": "espacio seleccionado para visita",
  "table.visitBarPlural": "espacios seleccionados para visita",
  "table.scheduleVisits": "Agendar visitas",

  // ── BeforeAfterSection ──
  "beforeAfter.badge": "Antes vs Después",
  "beforeAfter.heading": "Modelo tradicional vs. Woba",
  "beforeAfter.subheading": "Menos etapas, menos costo, más control.",
  "beforeAfter.traditional": "Tradicional",
  "beforeAfter.withWoba": "Con Woba",
  "beforeAfter.trad.suppliers": "13",
  "beforeAfter.trad.suppliersDesc": "proveedores diferentes",
  "beforeAfter.trad.timeline": "3–6",
  "beforeAfter.trad.timelineDesc": "para implementar la operación",
  "beforeAfter.trad.timelineSuffix": "meses",
  "beforeAfter.trad.variableCosts": "Costos variables",
  "beforeAfter.trad.variableCostsDesc": "sorpresas diferentes cada mes",
  "beforeAfter.trad.closedContract": "Contrato cerrado",
  "beforeAfter.trad.closedContractDesc": "multas de 3 a 6 meses por rescisión",
  "beforeAfter.trad.noVisibility": "Sin visibilidad",
  "beforeAfter.trad.noVisibilityDesc": "datos dispersos en varios proveedores",
  "beforeAfter.trad.blindDecision": "Decisión a ciegas",
  "beforeAfter.trad.blindDecisionDesc": "sin datos para optimizar costos",
  "beforeAfter.woba.singleContract": "1",
  "beforeAfter.woba.singleContractDesc": "contrato único, todo incluido",
  "beforeAfter.woba.timeline": "15",
  "beforeAfter.woba.timelineDesc": "operando con onboarding completo",
  "beforeAfter.woba.timelineSuffix": "días",
  "beforeAfter.woba.fixedValue": "Valor fijo mensual",
  "beforeAfter.woba.fixedValueDesc": "sin sorpresas, sin costos ocultos",
  "beforeAfter.woba.onDemand": "Arma bajo demanda",
  "beforeAfter.woba.onDemandDesc": "expande, reduce o cambia sin multa",
  "beforeAfter.woba.dashboard": "Dashboard en tiempo real",
  "beforeAfter.woba.dashboardDesc": "ocupación, costos y uso en un solo lugar",
  "beforeAfter.woba.ai": "IA que optimiza la operación",
  "beforeAfter.woba.aiDesc": "identifica desperdicio y sugiere ajustes",
  "beforeAfter.woba.bestPrice": "Mejor precio garantizado",
  "beforeAfter.woba.bestPriceDesc":
    "mismo valor que contratación directa — con toda la plataforma incluida",
  "beforeAfter.accordionLabel": "Ver detalle de los 13 costos que eliminas",
  "beforeAfter.accordionIntro": "Lo que necesitarías gestionar por separado:",
  "beforeAfter.accordionCat1": "Alquiler + Condominio + Impuestos (48-58%)",
  "beforeAfter.accordionCat1.rent": "Alquiler base",
  "beforeAfter.accordionCat1.condo": "Condominio",
  "beforeAfter.accordionCat1.tax": "Impuestos",
  "beforeAfter.accordionCat2": "Servicios operacionales (28-35%)",
  "beforeAfter.accordionCat2.energy": "Energía",
  "beforeAfter.accordionCat2.staff": "Staff operacional",
  "beforeAfter.accordionCat2.cleaning": "Limpieza",
  "beforeAfter.accordionCat2.internet": "Internet / Telecom",
  "beforeAfter.accordionCat2.maintenance": "Mantenimiento",
  "beforeAfter.accordionCat2.water": "Agua",
  "beforeAfter.accordionCat3": "Soporte y depreciación (12-18%)",
  "beforeAfter.accordionCat3.furniture": "Mobiliario (depreciación)",
  "beforeAfter.accordionCat3.coffee": "Café / Amenities",
  "beforeAfter.accordionCat3.insurance": "Seguros",
  "beforeAfter.accordionCat3.admin": "Admin / Overhead",
  "beforeAfter.accordionSummaryBold1": "13 ítems",
  "beforeAfter.accordionSummaryMiddle":
    "para gestionar, 13 proveedores, 13 contratos.",
  "beforeAfter.accordionSummaryBold2": "Con Woba, todo en 1.",

  // ── NetworkSection ──
  "network.badge": "Red Woba",
  "network.heading": "Contratas una oficina.\nTe llevas un país entero.",
  "network.subheading":
    "Al contratar por Woba, tu equipo no queda atado a una dirección. Con los créditos incluidos en el plan, puede usar salas de reunión, estaciones de trabajo y espacios de eventos en cualquier ciudad de Brasil.",
  "network.stat.flexibleOffices": "oficinas flexibles",
  "network.stat.meetingRooms": "salas de reunión",
  "network.stat.eventSpaces": "espacios de eventos",
  "network.stat.cities": "ciudades en América Latina",
  "network.type.workstations": "Estaciones de Trabajo",
  "network.type.workstationsDescPre": "1 diaria en cualquiera de las",
  "network.type.workstationsDescCount": "+23.000",
  "network.type.workstationsDescPost": "estaciones",
  "network.type.meetingRooms": "Salas de Reunión",
  "network.type.meetingRoomsDescPre": "1 hora en cualquiera de las",
  "network.type.meetingRoomsDescCount": "+4.200",
  "network.type.meetingRoomsDescPost": "salas",
  "network.type.eventSpaces": "Espacios de Eventos",
  "network.type.eventSpacesDescPre": "1 diaria en cualquiera de los",
  "network.type.eventSpacesDescCount": "+1.000",
  "network.type.eventSpacesDescPost": "espacios",
  "network.type.privateOffices": "Oficinas Privadas",
  "network.type.privateOfficesDescPre": "1 mes en cualquiera de las",
  "network.type.privateOfficesDescCount": "+5.200",
  "network.type.privateOfficesDescPost": "oficinas",
  "network.credits": "créditos",
  "network.creditsPerPerson": "créditos/persona",
  "network.creditsPerPosition": "créditos/posición",

  // ── FlexibilitySection ──
  "flexibility.title": "Tu operación cambia. Tu contrato acompaña.",
  "flexibility.desc":
    "¿Necesitas más posiciones? Expandimos. ¿Necesitas reducir? Renegocia sin multa abusiva. ¿Quieres cambiar de dirección? Hacemos la migración.",

  // ── NextStepsSection ──
  "nextSteps.heading": "Próximos Pasos",
  "nextSteps.subheading": "Del interés a la operación en pocos días",
  "nextSteps.step1.title": "Agenda una visita",
  "nextSteps.step1.desc": "Conoce el espacio en persona",
  "nextSteps.step1.timing": "Hoy",
  "nextSteps.step2.title": "Propuesta final",
  "nextSteps.step2.desc": "Valores, condiciones y SLA",
  "nextSteps.step2.timing": "48h después de la visita",
  "nextSteps.step3.title": "Firma y ocupa",
  "nextSteps.step3.desc": "Contrato digital, mudanza coordinada por Woba",
  "nextSteps.step3.timing": "Hasta 15 días",
  "nextSteps.scheduleVisits": "Agendar visitas",
  "nextSteps.seeSpaces": "Mira los espacios seleccionados y agenda tu visita.",
  "nextSteps.consultantQuestion":
    "¿Aún tienes dudas? Habla con nuestra especialista",
  "nextSteps.consultantRole": "Consultora Woba",

  // ── CTASection / Footer ──
  "cta.tagline": "La forma más inteligente de contratar y administrar oficinas",
  "cta.contact": "Contacto",
  "cta.proposal": "Propuesta",
  "cta.generatedOn": "Generada el:",
  "cta.validUntil": "Válida hasta:",
  "cta.validTBD": "Por definir",
  "cta.copyright": "© {{year}} Woba. Todos los derechos reservados.",
  "cta.pricesGuaranteedUntil": "Precios garantizados hasta",
  "cta.afterDate":
    "Después de esa fecha, valores ajustados según disponibilidad",
  "cta.scheduleVisits": "Agendar visitas",
  "cta.chooseSpaces": "Elegir espacios para visitar",
  "cta.scheduleVisitsCount": "Agendar visita en {{count}} local",
  "cta.scheduleVisitsCountPlural": "Agendar visitas en {{count}} locales",

  // ── LogosSection ──
  "logos.socialProof": "Algunas de las miles de empresas que confían en Woba",

  // ── FlexCreditsSection ──
  "flexCredits.label": "Créditos Flexibles Extras",
  "flexCredits.perMonth": "créditos/mes",
  "flexCredits.learnMore": "Saber más",

  // ── ScheduleModal ──
  "schedule.title": "Agendar Visitas",
  "schedule.subtitle": "Elige la fecha y horario para cada espacio",
  "schedule.availableUntil": "Agendamientos disponibles hasta",
  "schedule.chooseDate": "Elige la fecha",
  "schedule.chooseTime": "Elige el horario",
  "schedule.confirm": "Confirmar agendamiento",
  "schedule.sending": "Enviando...",
  "schedule.sentLabel": "Agendamiento enviado —",
  "schedule.at": "a las",
  "schedule.successTitle": "¡Solicitud enviada!",
  "schedule.successSubtitle": "Tus visitas fueron solicitadas",
  "schedule.successNotice":
    "Los horarios aún dependen de confirmación del espacio. Te contactaremos pronto.",
  "schedule.understood": "Entendido",

  // ── Spaces (additional) ──
  "spaces.option": "Opción {{number}}",
  "spaces.ofTotal": "de {{total}}",

  // ── POI Categories ──
  "poi.restaurant": "Restaurantes",
  "poi.cafe": "Cafés",
  "poi.pharmacy": "Farmacias",
  "poi.transport": "Transporte",
  "poi.hotel": "Hoteles",
  "poi.parking": "Estacionamientos",

  // ── Chat (additional) ──
  "chat.defaultSpaceName": "este espacio",

  // ── FlexCredits (additional) ──
  "flexCredits.estimatedValue": "R$ {{value}}/mes",

  // ── LicenseFee ──
  "licenseFee.title": "License Fee",
  "licenseFee.paidSemiannually": "pago semestralmente",
  "licenseFee.paidAnnually": "pago anualmente",
  "setupFee.title": "Setup Fee",
  "setupFee.paidOnce": "pago una única vez",
};
